import { normalizeAuthRole } from '@/lib/auth-role';

/** Profils pouvant voir le menu formateur (création) dans la barre latérale, dont « Mes webinaires ». */
export function roleQualifiesForTrainerWebinarUi(role: string | undefined | null): boolean {
  const r = String(role ?? '').toLowerCase().trim();
  if (!r) return false;
  const n = normalizeAuthRole(r) ?? r;
  const allowed = new Set([
    'teacher',
    'resp_formation',
    'collaborateur',
    'manager',
    'institution_admin',
  ]);
  return allowed.has(r) || allowed.has(n);
}
